import { render, staticRenderFns } from "./Endurance8020.vue?vue&type=template&id=5ee20974&scoped=true"
import script from "./Endurance8020.vue?vue&type=script&lang=js"
export * from "./Endurance8020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee20974",
  null
  
)

export default component.exports